import React from 'react';
import { Table } from 'reactstrap';
import { Row, Col } from 'reactstrap';

import Page from '../../Common/Page';
import ListFromApi from '../ListFromApi';
import MemberRow from './MemberRow';

function MembersPage(props) {
    return (
        <Page centered>
            <h2>Tagjaink</h2>
            <Row>
                <Col>
                    <Table size="sm" responsive striped className="table">
                        <thead>
                            <tr className="bg-transparent">
                                <th>Név</th>
                                <th>Tisztség</th>
                                <th colSpan="2">Keresztszülők</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ListFromApi
                                url='/users/members'
                                errorMessage='A körtagok letöltése sikertelen.'
                                elementType={MemberRow}
                            />
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Page>
    );
}

export default MembersPage;